import { useLazyQuery } from "@apollo/client/react";

import { queryDocuments } from "@smart/manage-gql-operations-dom";

import { useQueryFactory } from "./base";

export const useLazyLoadMatterPermissions = () => {
  const [getPermissions, { loading }] = useLazyQuery(
    queryDocuments.matterPermissions,
  );

  return {
    getPermissions: async (variables: { matterIds: string[] }) => {
      const result = await getPermissions({ variables });
      return result.data?.matterPermissions;
    },
    loading,
  };
};

export const useLoadMatterPermisions = useQueryFactory(
  queryDocuments.matterPermissions,
  {
    map: ({ matterPermissions }) => matterPermissions,
  },
);
